import { useDispatch, useSelector } from 'react-redux';
import {
  createWhatsAppOrder,
  fetchAllOrders,
  fetchOrderById,
  changeOrderStatus,
  updateOrderDetails,
  cancelOrder,
  fetchOrderStats,
  fetchOrdersByDateRange,
  setFilters,
  resetFilters,
  clearError,
  clearSuccess,
  clearCurrentOrder,
  resetOrderState
} from '../redux/slices/orderSlice';

export const useOrders = () => {
  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.order);

  return {
    // State
    ...orderState,
    
    // Actions
    createOrder: (data) => dispatch(createWhatsAppOrder(data)),
    getOrders: (filters) => dispatch(fetchAllOrders(filters)),
    getOrder: (id) => dispatch(fetchOrderById(id)),
    updateStatus: (orderId, status) => dispatch(changeOrderStatus({ orderId, status })),
    updateOrder: (orderId, data) => dispatch(updateOrderDetails({ orderId, data })),
    cancelOrder: (orderId) => dispatch(cancelOrder(orderId)),
    getStats: () => dispatch(fetchOrderStats()),
    getOrdersByDateRange: (startDate, endDate) => dispatch(fetchOrdersByDateRange({ startDate, endDate })),
    
    // Filter actions
    setOrderFilters: (filters) => dispatch(setFilters(filters)),
    resetOrderFilters: () => dispatch(resetFilters()),
    
    // Utility actions
    clearOrderError: () => dispatch(clearError()),
    clearOrderSuccess: () => dispatch(clearSuccess()),
    clearSelectedOrder: () => dispatch(clearCurrentOrder()),
    resetOrderData: () => dispatch(resetOrderState())
  };
};

export { useMyOrders } from './useMyOrders';